
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);
}

export function formatDate(date: Date): string {
  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
}

export function calculateSqft(length: number, height: number): number {
  return Math.round((length * height) / 144);
}

export function calculatePricePerSqft(price: number, sqft: number): number {
  if (sqft === 0) return 0;
  return Math.ceil(price / sqft);
}

export const stockStatusStyles = {
  outOfStock: {
    badge: "bg-red-100 text-red-700 hover:bg-red-200",
    text: "text-red-700",
  },
  lowStock: {
    badge: "bg-orange-100 text-orange-700 hover:bg-orange-200",
    text: "text-orange-700",
  },
};

export function getFullImageUrl(imageUrl: string): string {
  if (!imageUrl) return '/placeholder.svg';
  
  // Se já for uma URL completa (http ou https), retorna ela mesma
  if (imageUrl.startsWith('http')) return imageUrl;
  
  // Constrói a URL completa do bucket do Supabase
  const fullUrl = `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/slab-images/${imageUrl}`;
  console.log('URL da imagem gerada:', fullUrl);
  return fullUrl;
}
